import TableColumn from "@component/common/TableColumn";
import TableHeader from "@component/common/TableHeader";
import { CHALLENGE_PARTICIPANT_INFO } from "@constant/CHALLENGE_PARTICIPANT_INFO";

export default function ChallengeParticipantColumn() {
  return (
    <TableHeader>
      {CHALLENGE_PARTICIPANT_INFO.map(({ COLUMN, WIDTH }, index) => {
        return (
          <TableColumn key={index} width={WIDTH}>
            {COLUMN}
          </TableColumn>
        );
      })}
    </TableHeader>
  );
}
